import { ChangeDetectionStrategy, Component, inject, input, output, computed, ViewEncapsulation } from '@angular/core';
import { IPeriodDateRange } from '../../fi-time-range-menu/fi-time-range-menu';
import { INameIdObj } from '../../fi-shared-interfaces';
import { AppTextService } from '../../app-text';
import { Animations } from '../../utils/animations';

@Component({
    selector: 'fi-report-widget-details-header',
    templateUrl: './fi-report-widget-details-header.component.html',
    styleUrls: ['./fi-report-widget-details-header.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-report-widget-details-header' },
    standalone: false,
    animations: [Animations.fade],
})
export class FiReportWidgetDetailsHeaderComponent<T> {
    public title = input.required<string>();
    public isSaveFilterButtonVisible = input.required<boolean>();
    public widgetName = input.required<string>();
    public isFilterExpanded = input.required<boolean>();
    public isTimeRangeMenuVisible = input<boolean>(true);
    public isToggleFilterButtonVisible = input<boolean>(true);

    public tooltipTextId = input<string>('task2.date_menu_tooltip');
    public isTooltipVisible = input<boolean>(true);
    protected tooltipText = computed(() =>
        this.isTooltipVisible() ? this.appTextService.get(this.tooltipTextId()) : '',
    );

    public timeIntervalOptions = input<INameIdObj[]>();
    public customDateRangeValue = input<number>();
    public periodDateRange = input<IPeriodDateRange<T>>();
    public periodDateRangeChange = output<IPeriodDateRange<T>>();

    public toggleFilterVisibility = output<void>();
    public onSaveFilter = output<void>();
    public onSaveWidget = output<void>();
    public onBackButtonClick = output<void>();

    private appTextService = inject(AppTextService);

    protected saveFilterLabel = computed(() => {
        const isCustomWidget = !!this.widgetName()?.length;
        return this.appTextService.get(isCustomWidget ? 'common.update_widget' : 'save_filter');
    });
}
